module.exports = __webpack_public_path__ + "img/right-cloud.ec0c4ac1.png";